export default __webpack_public_path__ + "static/media/category-60.f638b5fa.svg";